import PubSub from "pubsub-js";

var LeasingPopupSlide = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-LeasingPopupSlide',
	};

	$.extend(true, this.options, options);

};

LeasingPopupSlide.prototype.init = function() {

	let self = this;

	let $selectorButtons = this.options.$el.find("a[data-slideindex]");
	$selectorButtons.on("click", function(e){
		e.preventDefault();
		let $el = $(this);
		let gaAction = $el.html().replace(" ", "_").toLowerCase();
		if(typeof gtag !== "undefined"){
			gtag('event', 'leasing_widget_button' + gaAction + "_clicked", {
				'event_category': 'leasing_widget'
			});
		}
		PubSub.publish("LeasingPopup.handleSelectorButtonClick", $el.data("slideindex"));
	});

	let $form = this.options.$el.find("form");
	if($form.length){
		self.initAnalyticsTrackingOnSubmission($form)
	}

	let $calendarButton = this.options.$el.find(".el-LeasingPopupSlide__calendar-wrapper__content .atom-ButtonPrimary");
	$calendarButton.on("click", function(){
		if(typeof gtag !== "undefined"){
			gtag('event', 'leasing_widget_schedule_clicked', {
				'event_category': 'leasing_widget'
			});
		}
		if(typeof fbq !== "undefined"){
			fbq('track', 'Lead');
		}
		setTimeout(function(){
			PubSub.publish("LeasingPopup.showThankyou");
		},1000);
	});

};

LeasingPopupSlide.prototype.initAnalyticsTrackingOnSubmission = function($form){

	let submitHandler = null;
	$form[0].addEventListener('onBeforeFormieSubmit', onBeforeSubmit);
	$form[0].addEventListener('onFormieValidate', onValidate);

	// Save for later to trigger real submit
	function onBeforeSubmit(e) {
		submitHandler = e.detail.submitHandler;
	}

	// Prevent the form from submitting while we check some things
	function onValidate(e) {

		e.preventDefault();
		let invalid = typeof e.detail.invalid === "undefined" ? false : e.detail.invalid;

		if (invalid) {
			submitHandler.formSubmitError();
		} else {
			
			setTimeout(function(){
				PubSub.publish("LeasingPopup.showThankyou");
				submitHandler.submitForm();
			},1000);
		
		}

	}

};

export default LeasingPopupSlide;
